<template>
  <BaseLink
    :to="url"
    target="_blank"
    aria-label="Start FREE"
    class="bg-primary text-[#1C1E22] hover:bg-secondary duration-300 py-[0.4rem] px-[0.7rem] lg:py-[0.5rem] lg:px-[1rem] text-md rounded-sm flex text-nowrap"
    @click.prevent="openInNewTab"
  >
    Start FREE
  </BaseLink>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  const isMobile = ref(window.innerWidth < 768);
  const url = ref('https://app.patchstack.com/register');

  const openInNewTab = () => {
    if (isMobile.value) {
      window.open(url.value, '_blank');
    }
  };
</script>
